import React from 'react';
import { CopyTwoTone } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import { Button, message } from 'antd';
import moment from 'moment';
import { ShopmanagerInvoice, Invoice } from '../../store/invoice/useGetInvoice';
import { convertCurrency } from '../../helpers/convertCurrency';
import { CellWithTooltip } from '../../components/DataView/EditableTable';
import { useInvoiceMutation } from '../../store/invoice/useInvoiceLink';

export enum BillToReceiveStatus {
    CANCELADO = 'CANCELADO',
    PAGO = 'PAGO',
    VENCEHOJE = 'VENCE HOJE',
    AVENCER = 'À VENCER',
    ATRASADO = 'ATRASADO',
    PAGTO_PARCIAL = 'PARCIALMENTE PAGO',
}

export const ButtonLink = ({
    code,
    barcode,
}: {
    code: number;
    barcode: string;
}) => {
    const { mutateAsync, isLoading } = useInvoiceMutation();

    const handleLink = async () => {
        try {
            const response = await mutateAsync({ code, barcode });
            window.open(response.link);
        } catch (err) {
            message.error(
                'Ops, Aconteceu algo de errado, tente novamente mais tarde.',
            );
        }
    };

    return (
        <Button
            type="link"
            onClick={handleLink}
            style={{ color: '#000000' }}
            disabled={isLoading}
        >
            {!isLoading && 'Baixar'}
            {isLoading && 'Aguarde..'}
        </Button>
    );
};

export const columnsTicket: ColumnsType = [
    {
        title: 'ID lojista',
        dataIndex: 'shopmanager',
        key: 'shopmanager',
        width: 89,
        ellipsis: true,
        align: 'center',
        render: (shopManager: ShopmanagerInvoice) => shopManager.id,
    },
    {
        title: 'CPF/CNPJ',
        dataIndex: 'doc',
        key: 'doc',
        width: 140,
        ellipsis: true,
        align: 'center',
        render: (doc: string) => doc,
    },
    {
        title: 'E-mail lojista',
        dataIndex: 'shopmanager',
        key: 'shopmanager',
        width: 180,
        ellipsis: true,
        align: 'center',
        render: (shopManager: ShopmanagerInvoice) => shopManager.user.email,
    },
    {
        title: 'Data de emissão do boleto',
        dataIndex: 'issuedAt',
        key: 'issuedAt',
        width: 140,
        ellipsis: true,
        align: 'center',
        render: (issueAt: string) =>
            issueAt ? moment(issueAt).format('DD/MM/YYYY') : '',
    },
    {
        title: 'Data de vencimento do boleto',
        dataIndex: 'dueDate',
        key: 'dueDate',
        width: 140,
        ellipsis: true,
        align: 'center',
        render: (dueDate: string) =>
            dueDate ? moment(dueDate).format('DD/MM/YYYY') : '',
    },
    {
        title: 'Valor',
        dataIndex: 'value',
        key: 'value',
        width: 140,
        ellipsis: true,
        align: 'center',
        render: (value: number) => {
            return (
                <CellWithTooltip
                    valueCell={convertCurrency('', value)}
                    ptbrCurrency
                />
            );
        },
    },
    {
        title: 'Status do boleto',
        dataIndex: 'status',
        key: 'status',
        width: 140,
        ellipsis: true,
        align: 'center',
        render: (status: keyof typeof BillToReceiveStatus) =>
            BillToReceiveStatus[status],
    },
    {
        title: 'Código de barras copia e cola',
        dataIndex: 'barcode',
        key: 'barcode',
        width: 250,
        align: 'center',
        render: (barcode: string) => {
            return (
                <>
                    {barcode && (
                        <>
                            <CopyTwoTone
                                style={{ fontSize: 24, cursor: 'pointer' }}
                                onClick={() => {
                                    navigator.clipboard.writeText(barcode);
                                    message.success(
                                        'Código de barras copiado!',
                                    );
                                }}
                            />{' '}
                            &nbsp; &nbsp;
                            <span>
                                {barcode.substring(0, 25).concat('...')}
                            </span>
                        </>
                    )}
                </>
            );
        },
    },
    {
        title: 'Baixar boleto em pdf',
        width: 140,
        align: 'center',
        render: (data: Invoice) => {
            return (
                <>
                    {data.barcode && data.barcode && (
                        <ButtonLink barcode={data.barcode} code={data.code} />
                    )}
                </>
            );
        },
    },
];
